import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { createStructuredSelector } from 'reselect';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Row, Col, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import _findIndex from 'lodash/findIndex';
import Shortcut, { ShortcutProvider } from '@tekion/tekion-components/src/molecules/Accessibility/Shortcuts';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import { fetchCardsList, fetchFavCardsList, addFavoriteCards } from './LeftNav.action';
import { cardListSelector, favCardListSelector, getActiveCard, makeFavPinnedCards, menuItemsListSelector } from './LeftNav.selector';
import LeftNavPinnedCards from '../../atoms/LeftNavPinnedCards';
import Logout from '../../atoms/Logout/Logout';
import LeftNavMenu from '../../atoms/LeftNavMenu/LeftNavMenu';
import TekionLogo from '../../atoms/TekionLogo/TekionLogo';
import { injectLink } from '../../utils/helper';
class LeftNavComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleMandatoryFields = (e, type) => {
      this.setState({
        [type]: e.target.value
      });
    };
    this.onFavIconClick = card => e => {
      e.stopPropagation();
      const {
        favouriteCards,
        pinFavoriteCards,
        apiBaseUrl
      } = this.props;
      let payload = [];
      const favArray = [...favouriteCards];
      const pinIndex = _findIndex(favArray, {
        appKey: card
      });
      if (pinIndex > -1) {
        favArray.splice(pinIndex, 1);
        for (let i = pinIndex; i < favArray.length; i += 1) {
          favArray[i].pinOrder -= 1;
        }
        payload = [...favArray];
      } else {
        const applicationPins = {
          appKey: card,
          pinOrder: favouriteCards.length
        };
        payload = [...favouriteCards, applicationPins];
      }
      pinFavoriteCards(payload, apiBaseUrl);
    };
    this.handleCardNavigation = val => () => {
      this.setState({
        collapsed: true,
        isActive: false
      }, () => {
        const {
          path,
          is_external: isExternal
        } = val;
        if (isExternal) {
          window.open(path, '_blank');
        } else {
          const {
            pathname
          } = window.location;
          if (path === pathname) {
            return;
          }
          window.location.href = "".concat(window.location.origin).concat(path);
        }
      });
    };
    this.toggleCollapsed = () => {
      const {
        collapsed,
        isActive
      } = this.state;
      this.setState({
        collapsed: !collapsed,
        isActive: !isActive,
        searchText: ''
      });
    };
    this.handleCloseMenu = () => {
      this.setState({
        collapsed: true,
        isActive: false,
        searchText: ''
      });
    };
    this.state = {
      collapsed: true,
      isActive: false
    };

    // Inject Font Icons
    injectLink('https://com-tekioncloud-cdms-global.s3.us-west-1.amazonaws.com/TAP/v1.1.2/fonts/tapicon/style.css');
  }
  componentDidMount() {
    const {
      getCardList,
      getFavCardList,
      apiBaseUrl
    } = this.props;
    getCardList(apiBaseUrl);
    getFavCardList(apiBaseUrl);
  }
  render() {
    const {
      collapsed
    } = this.state;
    const {
      favPinnedCards,
      settingsUrl,
      cards,
      menuItems,
      activeCard
    } = this.props;
    const {
      isActive
    } = this.state;
    return /*#__PURE__*/React.createElement(DndProvider, {
      backend: HTML5Backend
    }, /*#__PURE__*/React.createElement(ShortcutProvider, null, /*#__PURE__*/React.createElement(Shortcut, {
      held: [['Meta'], ['Control']],
      ordered: ['\\'],
      onMatch: this.toggleCollapsed,
      ignoreInput: true
    }), /*#__PURE__*/React.createElement(Shortcut, {
      ordered: ['Escape'],
      onMatch: this.handleCloseMenu,
      ignoreInput: true
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(collapsed ? 'hamburger-menu-btn-container' : 'hamburger-menu-btn-container leftNavZindex')
    }, /*#__PURE__*/React.createElement("div", {
      className: "hamburger-menu-btn-and-logo"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: this.toggleCollapsed,
      className: "hamburger-menu-btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: isActive ? 'icon-close' : 'icon-nine-dots-menu'
    })), !collapsed && /*#__PURE__*/React.createElement(TekionLogo, {
      showProd: true
    })), /*#__PURE__*/React.createElement(LeftNavPinnedCards, _extends({
      allCards: cards,
      favPinnedCards: favPinnedCards,
      handleCardNavigation: this.handleCardNavigation,
      inlineCollapsed: collapsed,
      activeCard: activeCard
    }, this.props)), /*#__PURE__*/React.createElement("div", {
      className: "user-details hidden-desktop"
    }, /*#__PURE__*/React.createElement("a", {
      href: settingsUrl
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon-settings"
    })), /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement(UserOutlined, null)), /*#__PURE__*/React.createElement(Logout, null))), !collapsed ? /*#__PURE__*/React.createElement(LeftNavMenu, _extends({
      allCards: cards,
      menuItems: menuItems,
      handleCardNavigation: this.handleCardNavigation,
      onFavIconClick: this.onFavIconClick
    }, this.props)) : null));
  }
}
LeftNavComponent.propTypes = {
  apiBaseUrl: PropTypes.string.isRequired,
  cards: PropTypes.array.isRequired,
  getCardList: PropTypes.func.isRequired,
  getFavCardList: PropTypes.func.isRequired,
  pinFavoriteCards: PropTypes.func.isRequired,
  favouriteCards: PropTypes.array.isRequired,
  favPinnedCards: PropTypes.array.isRequired,
  settingsUrl: PropTypes.string
};
LeftNavComponent.defaultProps = {
  settingsUrl: '/app/settings'
};

/**
 * @description Map the state objects (as props) that are required to render the details in the UI
 */
const mapStateToProps = createStructuredSelector({
  cards: cardListSelector(),
  menuItems: menuItemsListSelector(),
  favouriteCards: makeFavPinnedCards(),
  favPinnedCards: favCardListSelector(),
  activeCard: getActiveCard()
});

/**
 * @description Map the actions (as props) that are required to dispatch actions from UI
 */
const mapDispatchToProps = dispatch => {
  const getCardList = bindActionCreators(fetchCardsList, dispatch);
  const getFavCardList = bindActionCreators(fetchFavCardsList, dispatch);
  const pinFavoriteCards = bindActionCreators(addFavoriteCards, dispatch);
  return {
    getCardList,
    getFavCardList,
    pinFavoriteCards
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LeftNavComponent);